import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppStyle from '../../../styles/App.module.css';
import { Modal} from '@material-ui/core';

const WIDTH = 700;

const styles = theme => ({
    paper: {
        padding: '0px',
        position: 'absolute',
        // width: theme.spacing.unit * 50,
        width: `${WIDTH}px`,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        outline: 'none',
        left: `calc(50% - ${WIDTH / 2}px)`,
        top: '150px',
    }
});
const SimpleModal = (props) => {
    const { classes } = props;

    return (
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={props.open}
            onClose={props.cancelModal}
        >
            <div className={classes.paper}>
                <div className={AppStyle.Location__Title}>
                    <span>{props.titleModal}</span>
                </div>
                {props.children}
            </div>
        </Modal>
    );
}
export default withStyles(styles)(SimpleModal);